import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { screenshotResourceLoadingClass } from "healthex-common/screenshot.dtos";
export function withLoadTracking(ImageComponent) {
    const WithLoadTrackingComponent = (props) => {
        var _a;
        const { isScreenshotMode, ...imageProps } = props;
        const [hasLoaded, setHasLoaded] = React.useState(false);
        const imageRef = React.useRef(null);
        React.useEffect(() => {
            if (imageProps.src === undefined) {
                setHasLoaded(true);
                return;
            }
            if (imageRef.current && imageRef.current.complete && imageRef.current.naturalWidth > 0) {
                setHasLoaded(true);
            }
        }, [imageProps.src]);
        const handleLoad = React.useCallback((event) => {
            setHasLoaded(true);
            if (imageProps.onLoad) {
                imageProps.onLoad(event);
            }
        }, [imageProps.onLoad]);
        const handleError = React.useCallback((event) => {
            setHasLoaded(true);
            if (imageProps.onError) {
                imageProps.onError(event);
            }
        }, [imageProps.onError]);
        const shouldHaveLoadingClass = isScreenshotMode && !hasLoaded;
        const finalClassName = `${(_a = imageProps.className) !== null && _a !== void 0 ? _a : ""} ${shouldHaveLoadingClass ? screenshotResourceLoadingClass : ""}`.trim();
        return _jsx(ImageComponent, { ...imageProps, ref: imageRef, className: finalClassName, onLoad: handleLoad, onError: handleError });
    };
    WithLoadTrackingComponent.displayName = `withLoadTracking(${ImageComponent.displayName || ImageComponent.name})`;
    return WithLoadTrackingComponent;
}
